import { render, staticRenderFns } from "./Future.vue?vue&type=template&id=1d2b1fa9&"
import script from "./Future.vue?vue&type=script&lang=js&"
export * from "./Future.vue?vue&type=script&lang=js&"
import style0 from "./Future.vue?vue&type=style&index=0&id=1d2b1fa9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports